import { render, staticRenderFns } from "./ItemActionsDropdown.vue?vue&type=template&id=51da338c&scoped=true"
import script from "./ItemActionsDropdown.vue?vue&type=script&lang=js"
export * from "./ItemActionsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ItemActionsDropdown.vue?vue&type=style&index=0&id=51da338c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da338c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51da338c')) {
      api.createRecord('51da338c', component.options)
    } else {
      api.reload('51da338c', component.options)
    }
    module.hot.accept("./ItemActionsDropdown.vue?vue&type=template&id=51da338c&scoped=true", function () {
      api.rerender('51da338c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/browser/item-overlays/ItemActionsDropdown.vue"
export default component.exports